import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMixIngredientsGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m31.967 14.348-2-6.348-6.45 1.97 2 6.36 6.45-1.981Zm-2.833-4.793 1.256 3.991-4.05 1.238-1.255-3.991 4.049-1.238ZM15.219 22.212a4.006 4.006 0 0 0 2.11.605c.302 0 .603-.03.904-.1a3.953 3.953 0 0 0 2.482-1.743 3.895 3.895 0 0 0 .512-2.961c-.492-2.11-2.632-3.427-4.772-2.951-2.14.485-3.486 2.595-2.994 4.704a3.9 3.9 0 0 0 1.758 2.446Zm1.507-5.952c.201-.05.412-.07.613-.07 1.246 0 2.371.842 2.663 2.09.16.704.04 1.427-.352 2.03a2.75 2.75 0 0 1-1.698 1.2 2.729 2.729 0 0 1-2.06-.348 2.714 2.714 0 0 1-1.215-1.673 2.694 2.694 0 0 1 2.05-3.229Zm16.004 3.813-.693 6.487v.01H37v.614C37 34.246 31.163 40 24 40s-13-5.744-13-12.816v-.614h16.446l-3.607-2.585 8.891-3.912Zm-1.476 2-4.923 2.16 3.255 2.327h1.195l.473-4.486Zm-18.988 5.715C12.597 33.89 17.73 38.752 24 38.752s11.403-4.863 11.724-10.964H12.266Z",
    fill: "currentColor"
  }));
}

export { SvgMixIngredientsGlyph as default };
